import { IonCol, IonInput, IonLabel, IonRow } from '@ionic/react';
import { useRef, useState } from 'react';
import { IonWrapper } from './OtpInput.styles';

interface IComponentProps {
  theme: 'dark' | 'light';
  changeCallback: (otp: string) => void;
}

const OtpInput: React.FC<IComponentProps> = ({ theme, changeCallback }) => {
  const [digits, setDigits] = useState(Array(6).fill(''));
  const otpInputsRef = useRef<(HTMLIonInputElement | null)[]>([]);

  const handleOtpInputChange = (e: any, index: number) => {
    const value = e.target.value.substring(e.target.value.length - 1);
    if (/^\d?$/.test(value)) {
      // Ensure only digits are entered
      const newDigits = [...digits];
      newDigits[index] = value;
      setDigits(newDigits);
      if (value && index < digits.length - 1) {
        otpInputsRef.current[index + 1]?.setFocus(); // Move focus to the next input
      }
      changeCallback(newDigits.join(''));
    }
  };

  const handleOtpKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      otpInputsRef.current[index - 1]?.setFocus(); // Move focus to the previous input on backspace
    }
  };

  return (
    <IonWrapper className={theme}>
      <IonLabel className="otp-label">Enter your one-time password</IonLabel>
      <IonRow className="otp-row">
        {digits.map((digit, i) => (
          <IonCol key={i} className="otp-col">
            <IonInput type="text" maxlength={2} value={digit} onIonInput={(e) => handleOtpInputChange(e, i)} onKeyDown={(e) => handleOtpKeyDown(e, i)} ref={(el) => (otpInputsRef.current[i] = el)} className="otp-input" inputMode="numeric" />
          </IonCol>
        ))}
      </IonRow>
    </IonWrapper>
  );
};

export default OtpInput;
